import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import firebase from 'firebase';
import { LanguagesService } from '../services/languages.service';
import { VariablesService } from '../services/variables.service';

@Component({
  selector: 'app-success-stories',
  templateUrl: './success-stories.component.html',
  styleUrls: ['./success-stories.component.css']
})
export class SuccessStoriesComponent implements OnInit {
  cardslist
  success_list=[]
  success_list_f=[]
  success_one_page=5
  total_page_num=0
  page_list
  now_page
  show:boolean=false
  constructor(private router: Router) { 
    this.cardslist = Array(9).fill(0).map((x,i)=>i+1);
  }

  ngOnInit(): void {
    this.get_success()
    this.get_lang()
  
  }
  langstatus
  dir
  language
 get_lang(){
  this.langstatus=localStorage.getItem('language')
  this.dir=localStorage.getItem('dir')
  this.language=LanguagesService.language.success

}
  get_success(){
    this.show=true
    this.success_list=[]
  let  Ref_data = firebase.database().ref('success')
 
  Ref_data.once('value',snapshots=>{
    snapshots.forEach(snapshot=>{
  let y = snapshot.val()

    var date1 = new Date(y.date);
    y.date=  date1.toLocaleDateString()
    
    y.key = snapshot.key
    this.success_list.push(y)
  
  
    })
  }).then(()=>{
    this.success_list.reverse()
    let value_s=false
    let num = 1
    for(let index of this.success_list){ 
      index.num=num
      index.value=value_s
      value_s=!value_s
      num = num+1
    }
    this.total_page_num=Math.floor(this.success_list.length/this.success_one_page)+1
    if(  this.total_page_num<1){
      this.total_page_num=1
      
    }
    this.page_list = Array(this.total_page_num).fill(this.total_page_num).map((x,i)=>i+1);
    this.go_page(1)
 
  })
  }
go_page(num_page){
  this.now_page=num_page
    this.show=true
    setTimeout(()=>this.show=false,1000)
    this.gotoTop()
  this.success_list_f=[]
let first_num=1
let last_num=this.success_one_page
let first_num_f=0
let last_num_f=0
if(num_page==1){
  first_num_f=first_num
  last_num_f=last_num
  
}else{
  first_num_f=first_num+((num_page-1)*this.success_one_page)
  last_num_f=last_num+((num_page-1)*this.success_one_page)
}
for(let index of this.success_list){
  if(index.num >= first_num_f && index.num <= last_num_f){
    this.success_list_f.push(index)
  }
}
}

next_page(){
 
  this.go_page(this.now_page+1)
}
Previous_page(){
  this.go_page(this.now_page-1)
}
  read_more(event){
    VariablesService.project=event
     
    this.router.navigate(['success-stories/'+event.name_en])

  }

  gotoTop() {
    window.scroll({ 
      top: 0, 
      left: 0, 
      behavior: 'smooth' 
    });
  }
}
